import { render, staticRenderFns } from "./BaseListLink.vue?vue&type=template&id=22de2c26&scoped=true"
import script from "./BaseListLink.vue?vue&type=script&lang=js"
export * from "./BaseListLink.vue?vue&type=script&lang=js"
import style0 from "./BaseListLink.vue?vue&type=style&index=0&id=22de2c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de2c26",
  null
  
)

export default component.exports